export const invoicesNational = {
	title: "Invoices",
	description: "Individual download or group of invoices issued in the selected period.",
	acitons: {
		exportToExcel: "Export to Excel",
		downloadXml: "XML Download",
	},
	filters: {
		fiscalProfileLabel: "Fiscal Profile",
		invoiceNumberLabel: "Invoice number",
		invoiceNumberPlaceholder: "Search by invoice number",
		rangePickerLabel: "Issuance period",
		statusLabel: "Status",
		allInvoices: "All invoices",
		canceledInvoices: "Canceled invoices",
	},
	table: {
		issuedAt: "Issued At",
		mode: "Issuance mode",
		createdBy: "Employee",
		fiscalProfile: "Fiscal profile",
		eventDate: "Event date",
		isCanceled: "Canceled",
		serie: "Invoice series",
		num: "Invoice number",
		value: "Invoice value",
		actions: "Actions",
		downloadInvoice: {
			download: "Download",
			pdf: "PDF",
			image: "Image",
			xml: "XML",
			cancelXml: "Cancellation XML",
		},
		cancelInvoice: {
			yesCancel: "Yes, cancel invoice",
			confirm: "ok",
			areYouSure: "Are you sure you want to cancel the invoice?",
			cancel: "Cancel",
		},
		paginationTotal: " of {{total}}",
	},
};
